module.exports = __webpack_public_path__ + "static/img/tuandui.237b4e61.png";